/*
 * HomeReducer
 *
 * The reducer takes care of our data. Using actions, we can change our
 * application state.
 * To add a new action, add it to the switch statement in the reducer function
 *
 * Example:
 * case YOUR_ACTION_CONSTANT:
 *   return state.set('yourStateVariable', true);
 */
import { fromJS } from 'immutable';
import {
  CHECKOUT,
  DISCOUNT_CODE_APPLY_SUCCESS,
  EDIT_DISCOUNT_CODE,
  REMOVE_DISCOUNT_CODE,
} from './constants';

// The initial state of the Homepage
export const initialState = fromJS({
  productAdditions: [],
  discountCode: {
    applying: false,
    // code: "",
    showPopup: false,
    appliedCode: null,
    isValid: false,
  },
  atcStatus: {
    adding: false,
    added: false,
    spVariantID: 0,
  },
});

function homeReducer(state = initialState, action) {
  switch (action.type) {
    case CHECKOUT:
      if (action.discountCode.action === 'apply') {
        return state
          .setIn(['discountCode', 'applying'], true)
          .setIn(['discountCode', 'appliedCode'], null)
          .setIn(['discountCode', 'isValid'], false);
      }
      return state;

    case DISCOUNT_CODE_APPLY_SUCCESS:
      return state
        .setIn(['discountCode', 'applying'], false)
        .setIn(['discountCode', 'appliedCode'], action.discountCode.code)
        .setIn(['discountCode', 'isValid'], action.discountCode.isValid);

    case REMOVE_DISCOUNT_CODE:
      return state
        .setIn(['discountCode', 'applying'], false)
        .setIn(['discountCode', 'appliedCode'], null)
        .setIn(['discountCode', 'isValid'], false);

    case EDIT_DISCOUNT_CODE:
      return state
        .setIn(['discountCode', 'applying'], false)
        .setIn(['discountCode', 'applied'], false)
        .setIn(['discountCode', 'isValid'], false)
        .setIn(['discountCode', 'code'], action.code);
    default:
      return state;
  }
}

export default homeReducer;
